/**
 * Scripts for handling the functionality of dialog modals
 * Should be included at the end of the body so all the content 
 * is loaded to attach the event handlers to.
 */

/** Build dialogs for lightbox things (before all other dialog stuff is initialized) **/
let lightboxIndex = 1;

document.querySelectorAll(".wp-block-cover.opens-in-lightbox").forEach((lightbox) => {
	//Find the image
	let image = lightbox.querySelector('img').cloneNode(true);

	//Unique ID
	let modalId = lightbox.id ? `${lightbox.id}-lightbox` : `lightbox-${lightboxIndex}`;

	//Build the dialog
	let dialog = document.createElement('dialog');
	dialog.classList.add('lightbox-modal');
	dialog.id = modalId;

	//Add the close button to the dialog
	dialog.innerHTML = '<form class="close" method="dialog"><button class="is-style-plain" value="close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 256 438.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0L224 210.7 393.4 41.4z"/></svg></button></form>';

	//Add the image to the dialog
	dialog.appendChild(image);

	//Put the dialog in the DOM
	lightbox.after(dialog);

	//Change the href
	lightbox.querySelectorAll('a').forEach((anchor) => {
		anchor.href = '#'+modalId;
	});

	//Increment
	lightboxIndex++;

	//Add the click event listener
	let anchor = lightbox.querySelector('a');
	lightbox.addEventListener('click', (e) => {
		anchor.click();
	});
});

/** Build dialogs for video popups also */
document.querySelectorAll('.wp-block-button.video-popup').forEach((lightbox) => {
	//Find the video URL
	let videoUrl = lightbox.querySelector('a').href;

	//Unique ID
	let modalId = lightbox.id ? `${lightbox.id}-lightbox` : `lightbox-${lightboxIndex}`;

	//Build the dialog
	let dialog = document.createElement('dialog');
	dialog.classList.add('lightbox-modal');
	dialog.id = modalId;

	//Add the close button to the dialog
	dialog.innerHTML = '<form class="close" method="dialog"><button class="is-style-plain" value="close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 256 438.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0L224 210.7 393.4 41.4z"/></svg></button></form>';

	//Build the figure, div & iframe
	let figure = document.createElement('figure');
	figure.classList.add('wp-block-embed','is-type-video','is-provider-youtube','wp-block-embed-youtube','wp-embed-aspect-16-9','wp-has-aspect-ratio');

	let div = document.createElement('div');
	div.classList.add('wp-block-embed__wrapper');

	let iframe = document.createElement('iframe');
	iframe.src = videoUrl += '?feature=oembed&rel=0&enablejsapi=1';
	iframe.frameborder = 0;
	iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
	iframe.allowfullscreen = true;

	//Add the things to the dialog
	dialog.appendChild(figure);
	figure.appendChild(div);
	div.appendChild(iframe);

	//Put the dialog in the DOM
	lightbox.after(dialog);

	//Change the href
	lightbox.querySelectorAll('a').forEach((anchor) => {
		anchor.href = '#'+modalId;
	});

	//Increment
	lightboxIndex++;
});

/**
 * Checks if the url hash corresponds to a dialog element and opens it if applicable
 * @param {string} hash 
 */
function openModalByHash(hash) {

	// If the hash is empty close all open dialogs and return
	if (hash === '') {
		console.log('empty hash');
		document.querySelectorAll("dialog").forEach((dialog) => {
			if (dialog.open) dialog.close();
		});

		return;
	}

	// See if the hash matches a dom element
	let element = document.getElementById(hash.substring(1));
	
	if (element === null) return;
	
	// If the hash matches a dialog id, open it
	if (element.tagName === 'DIALOG') {
		element.showModal();

		//Start playing the video
		element.querySelectorAll("iframe").forEach((iframe) => {
			iframe.contentWindow.postMessage(
			    '{"event":"command","func":"playVideo","args":""}',
			    "*"
			);
		});
	}
}

// Onload if we're looking for a modal, open it up
if (window.location.hash) {
	openModalByHash(window.location.hash);
}

// Watch for the location hash to change and see if we need to do anything with modals
window.addEventListener('hashchange', () => {
	openModalByHash(window.location.hash);
}, false);

// Add a listener for the close events of modals and go back to the current page path
document.querySelectorAll("dialog").forEach((dialog) => {
	dialog.addEventListener("close", (e) => {
		if (dialog.id === window.location.hash.substring(1)) {
			window.history.pushState({}, '', window.location.pathname);
		}

		//Pause any videos that are playing
		document.querySelectorAll("dialog iframe").forEach((iframe) => {
			iframe.contentWindow.postMessage(
			    '{"event":"command","func":"pauseVideo","args":""}',
			    "*"
			);
		});
	}); 
});